// ----------------------------------------------------------------------
// <copyright file="Izenda.BackgroundImageContent.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
// </copyright>
// ----------------------------------------------------------------------

!(function() {


  var React = require('react');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Input = require('share/components/controls/Izenda.Input');
  var Validator = require('share/components/hoc/Izenda.Validator');
  var ValidatableInput = Validator()(Input);
  var EventsUtils = require('EventUtils');
  var dashboardConstants = require('logic/data/Izenda.DashboardConstants');
  const { cloneDeep } = require('lodash/fp');
  var propTypes = {
    save: React.PropTypes.func,
    close: React.PropTypes.func,
    imageUrl: React.PropTypes.string,
    stretchImage: React.PropTypes.bool,
    store: React.PropTypes.object.isRequired
  };

  var BackgroundImageContent = React.createClass({
    propTypes: propTypes,

    getInitialState: function() {
      return this.populateSate(this.props);
    },

    componentWillReceiveProps: function(nextProps) {
      this.setState(this.populateSate(nextProps));
    },

    /**
     * Build state information.
     * @param {Object} props
     * @return {Object}
     */
    populateSate: function(props) {
      var imageUrl = props.imageUrl || '';
      var stretchImage = props.stretchImage;

      return {
        imageUrl: imageUrl,
        stretchImage: stretchImage,
        originalUrl: cloneDeep(imageUrl),
        originalStretchImage: stretchImage
      };
    },

    onClosing: function(type) {
      var props = this.props;

      if (type === 'cancel') {
        return props.onReject();
      }

      var state = this.state;
      var imageUrl = state.imageUrl;
      var originalUrl = state.originalUrl;
      var stretchImage = state.stretchImage;
      var originalStretchImage = state.originalStretchImage;

      if (imageUrl !== originalUrl || stretchImage !== originalStretchImage) {
        return props.validation.validate('backgroundImage').then(function(success) {
          if (success) {
            props.save(imageUrl, stretchImage);
            props.onAccept();
          }
        });
      }
      return props.onAccept();
    },

    /**
     * Handle change value of image url control.
     * @param {String} type
     */
    onChangeImageUrl: function(value) {
      this.setState({
        imageUrl: value
      });
    },

    /**
     * Handle change value of stretch image control.
     * @param {String} type
     */
    onChangeStretchImage: function(value) {
      this.setState({
        stretchImage: value
      });
    },

    /**
     * Render body of popup.
     * @param {Object}
     */
    render: function() {
      var state = this.state;
      var store = this.props.store;
      var constants = dashboardConstants.BACKGROUND_IMAGE;

      var backgroundImageValidation = {
        action: function() {
          return store.validateImageUrl.bind(store, state.imageUrl);
        }
      };

      return (
        <GridLayout>
          <GridLayout.Row>
            <GridLayout.Col cols={2}>
              <span>{constants.IMAGE_URL_LABEL}</span>
            </GridLayout.Col>
            <GridLayout.Col cols={10}>
              <ValidatableInput
                field="backgroundImage"
                className="form-control"
                validations={backgroundImageValidation}
                value={state.imageUrl}
                onChange={EventsUtils.notifyChange(this.onChangeImageUrl, EventsUtils.INPUT)}
              />
            </GridLayout.Col>
          </GridLayout.Row>
          <GridLayout.Row>
            <GridLayout.Col cols={2}>
              <span>{constants.STRETCH_IMAGE_LABEL}</span>
            </GridLayout.Col>
            <GridLayout.Col cols={10}>
              <input
                type="checkbox"
                checked={state.stretchImage}
                onChange={EventsUtils.notifyChange(this.onChangeStretchImage, EventsUtils.CHECKBOX)}
              />
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
      );
    }
  });

  module.exports = {
    BackgroundImageContent: BackgroundImageContent,
    propTypes: propTypes,
    constants: dashboardConstants.BACKGROUND_IMAGE
  };
})();



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/BackgroundImage/Izenda.BackgroundImageContent.jsx